import { render, staticRenderFns } from "./RiwayatPenarikan.vue?vue&type=template&id=5e9762d5&scoped=true&"
import script from "./RiwayatPenarikan.vue?vue&type=script&lang=js&"
export * from "./RiwayatPenarikan.vue?vue&type=script&lang=js&"
import style0 from "./RiwayatPenarikan.vue?vue&type=style&index=0&id=5e9762d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9762d5",
  null
  
)

export default component.exports